import { AppBundle } from 'api/optimalprint-sdk.d';
import { AppDispatch, Store } from 'store';
import getProductItem from 'store/product/selector/getProductItem';
import getProductType from 'store/product/selector/getProductType';
import getPrice from 'store/price/selector/getPrice';
import { ProductType } from 'store/product/types';
import gtmProductViewEvent from 'utils/gtm/gtmProductViewEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmViewItemEvent from 'utils/gtm/gtmViewItemEvent';
import getGtmProductsData from '../selector/getGtmProductsData';

const sendGtmProductViewOperation = () => (dispatch: AppDispatch, getState: () => Store) => {
  const store = getState();

  const productType = getProductType(store);
  if (productType !== ProductType.predesigned) return;

  const item = getProductItem(store) as AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem;
  const { encDesignId, product } = item;
  if (!encDesignId || !product) return;

  const { productId, categoryId } = product;
  if (!productId || !categoryId) return;

  const gtmProductsData = getGtmProductsData(store);
  const gtmProductData = gtmProductsData[encDesignId];
  if (!gtmProductData) return;

  const price = getPrice(store, categoryId, productId, 1);
  const unitPrice = price ? price.ip : gtmProductData.price;

  gtmSendEvent(gtmProductViewEvent(gtmProductData));
  gtmSendEvent(gtmViewItemEvent({ ...gtmProductData, unitPrice }));
};

export default sendGtmProductViewOperation;
